import React from "react"
import { Container } from "./styles"

export const ButtonChangeView = ({ children, ...props }) => {
   return <Container {...props}>{children}</Container>
}
